import { requestorHelperService } from '@/requestors/requestor-helper-service.js';
import _ from 'lodash';

function getSlideRequest (data, title, subtitle, settings) {
    let chartSlide = { SlideType: 'clustered-bar-chart', ChartRequests: [] };
    chartSlide.Title = title || 'Brand Conversability Score by Social Network';
    chartSlide.Subtitle = subtitle;

    if (data) {
        chartSlide.ChartRequests.push(buildChartRequests(data, settings));
    }

    return chartSlide;
}

function buildChartRequests (data, settings) {
    let chartRequest = { Series: [], Legends: [] };
    chartRequest.YAxisTitle = settings.yAxis.label;
    chartRequest.XAxisTitle = settings.xAxis.label;
    chartRequest.YAxisNumberFormat = '0';

    if (data) {
        let seriesIndex = 0;
        settings.series.forEach(s => {
            chartRequest.Series.push({
                Index: seriesIndex,
                Name: s.name,
                Colour: s.colour,
                SeriesData: _(data)
                    .filter(d => d.networkId === s.id)
                    .map(d => ({ Category: d.brandName, YValue: d.score }))
                    .value()
            });

            chartRequest.Legends.push({
                Id: seriesIndex,
                Name: s.name,
                Colour: s.colour
            });
            seriesIndex++;
        });
    }
    return chartRequest;
}

class SocialnetworksComparisonRequestor {
    generatePPTXRequest (data, title, subtitle, settings) {
        return requestorHelperService.buildPresentationRequest(getSlideRequest, 'brand_scores_by_social_network.pptx', data, title, subtitle, settings);
    }

    getSlideRequest (data, title, subtitle, settings) {
        return getSlideRequest(data, title, subtitle, settings);
    }
}

export const socialnetworksComparisonRequestor = new SocialnetworksComparisonRequestor();
